import { CarrierFormType } from '~/pages/Settings/Carriers/CarrierForm/CarrierForm';
import Carrier from '~/types/Carrier';
import { CarrierFormField } from '~/types/CarrierFormField';
import { ActionKeys } from './constants';

export interface FetchCarrierFormFieldsSuccessPayload {
  carrierFormFields: CarrierFormField[];
  carrierFormFieldValidations: { [key: string]: ((data: string) => void)[] }; // Object contains keys to Array<func>
}

export interface FetchCarrierFormFieldsPayload {
  carrier: Carrier;
  formType: CarrierFormType;
}

export interface FetchCarrierFormFieldsErrorPayload {
  error: string;
}

// Clear State
export function carrierFormFieldsClearState() {
  return <const>{
    type: ActionKeys.CARRIER_FORM_FIELDS_CLEAR_STATE,
  };
}

// Fetch Form Fields
export function fetchCarrierFormFields(payload: FetchCarrierFormFieldsPayload) {
  return <const>{
    payload,
    type: ActionKeys.FETCH_CARRIER_FORM_FIELDS,
  };
}

export function fetchCarrierFormFieldsSuccess(payload: FetchCarrierFormFieldsSuccessPayload) {
  return <const>{
    payload,
    type: ActionKeys.FETCH_CARRIER_FORM_FIELDS_SUCCESS,
  };
}

export function fetchCarrierFormFieldsError(payload: FetchCarrierFormFieldsErrorPayload) {
  return <const>{
    payload,
    type: ActionKeys.FETCH_CARRIER_FORM_FIELDS_ERROR,
  };
}

export type CarrierFormFieldsActions =
  | ReturnType<typeof carrierFormFieldsClearState>
  | ReturnType<typeof fetchCarrierFormFields>
  | ReturnType<typeof fetchCarrierFormFieldsSuccess>
  | ReturnType<typeof fetchCarrierFormFieldsError>;
